import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Clickable from '../Clickable'

import { rewriteEbookUrl } from '../../../shared/lib/ebookUrl'

import closeImg from 'Assets/x-icon-gray.svg'

import baseStyle from 'Styles/base.css'
import style from './style.css'

export default function AssignmentReadingMobile (props) {
  let bottomNavigation = null
  if (props.score.activityGrade === 0 && !props.retake) {
    bottomNavigation = (
      <nav className={style.nextContainer}>
        <ul>
          {props.nextUnreadSection.takeQuiz !== true
            ? (
            <li
              className={style.nextNavigation}
              onClick={() => props.onNextItem()}
              dangerouslySetInnerHTML={{ __html: 'Next Section: ' + props.nextUnreadSection.label }}
            />
              )
            : (
            <li
              className={style.nextNavigation}
              onClick={() => props.startQuiz()}
              data-test-id="readingTakeQuizBtn"
            >
            Next: Take the Quiz!
            </li>
              )
          }
        </ul>
      </nav>
    )
  } else if (props.sections.cyuSectionsRemaining > 0 && props.selectedSection && !props.selectedSection.cyuComplete) {
    bottomNavigation = (
      <div
        className={style.nextContainer}
        onClick={props.openCheckUnderstandingModal}
      >
        <h3
          className={style.nextNavigation}
        >
          Check Your Understanding
        </h3>
      </div>
    )
  } else if ((props.sections.cyuSectionsRemaining === 0) && props.retake) {
    bottomNavigation = (
      <div className={style.nextContainer}>
        <h3
          className={style.nextNavigation}
          onClick={() => props.startQuiz()}
        >
          Retake the Quiz!
        </h3>
      </div>
    )
  }

  let url = props.data
  url = rewriteEbookUrl(url)

  if (props.isQuestionVisible) {
    return props.cyuModalView
  }

  return (
    <div className={style.container}>
      <div className={style.pageTitle}>
        <span
          dangerouslySetInnerHTML={{ __html: props.assignmentTitle }}
        />
        <Clickable
          data-test-id="closeVitalSourceEbook"
          className={style.headerClickableRight}
          onClick={props.onClick}
        >
          <input
            type="image"
            alt="close vital source ebook"
            src={closeImg}
            className={classnames(baseStyle.svgIcon, style.closeEbook)}
          />
        </Clickable>
      </div>
      <div className={style.innerContent}>
        <iframe
          src={url}
          className={classnames(style.vitalSourceFrame)}
          name={props.assignmentTitle}
          title={props.assignmentTitle}
        />
        {bottomNavigation}
      </div>
    </div>
  )
}

AssignmentReadingMobile.propTypes = {
  onClick: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired,
  isCYU: PropTypes.bool.isRequired,
  assignmentTitle: PropTypes.string.isRequired,
  nextUnreadSection: PropTypes.object,
  readingIncomplete: PropTypes.bool,
  onNextItem: PropTypes.func,
  startQuiz: PropTypes.func,
  score: PropTypes.object,
  openCheckUnderstandingModal: PropTypes.func,
  cyuModalView: PropTypes.object,
  isQuestionVisible: PropTypes.bool,
  sections: PropTypes.object,
  retake: PropTypes.bool,
  selectedSection: PropTypes.object
}
